import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class display
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.display = {};

/**
 * GET Endpoint `/display/template`
 * @param {string} type - widget type (e.g. schedule, medallion, etc.)
 * @param {number} [id]
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.display
 */
ReachAPI.display.getTemplate = function (type, id) {
    var url = ReachAPI.server + '/display/template/' + type;
    var idIsSet = Boolean(id !== undefined && id !== null && id !== '');
    var templateId = type + '/' + (idIsSet ? id : 'default');
    var jqPromise;

    if (idIsSet) {
        url += '/' + id;
    }

    jqPromise = ReachAPI.getWithFallback(url, 'text');

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Template `' + templateId + '` from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Template `' + templateId + '` from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to get Template `' + templateId + '`',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/display/template/css`
 * @param {string} type - widget type (e.g. schedule, medallion, etc.)
 * @param {number} [id]
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.display
 */
ReachAPI.display.getTemplateCss = function (type, id) {
    var url = ReachAPI.server + '/display/template/css/' + type;
    var idIsSet = Boolean(id !== undefined && id !== null && id !== '');
    var templateId = type + '/' + (idIsSet ? id : 'default');
    var jqPromise;

    if (idIsSet) {
        url += '/' + id;
    }

    jqPromise = ReachAPI.getWithFallback(url, 'text');

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Template CSS `' + templateId + '` from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Template CSS `' + templateId + '` from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to get Template CSS `' + templateId + '`',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/display/template/combined/`
 * @param {string} type - widget type (e.g. schedule, medallion, etc.)
 * @param {number} [id]
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.display
 */
ReachAPI.display.getTemplateCombined = function (type, id) {
    var url = ReachAPI.server + '/display/template/combined/' + type;
    var idIsSet = Boolean(id !== undefined && id !== null && id !== '');
    var templateId = type + '/' + (idIsSet ? id : 'default');
    var jqPromise;

    if (idIsSet) {
        url += '/' + id;
    }

    jqPromise = ReachAPI.getWithFallback(url, 'json');

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Template `' + templateId + '` from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Template `' + templateId + '` from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to get Template `' + templateId + '`',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
